import { render, staticRenderFns } from "./NoRole.vue?vue&type=template&id=7f8ca1b0&scoped=true"
import script from "./NoRole.vue?vue&type=script&lang=js"
export * from "./NoRole.vue?vue&type=script&lang=js"
import style0 from "./NoRole.vue?vue&type=style&index=0&id=7f8ca1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8ca1b0",
  null
  
)

export default component.exports